import Task from './Task';
import { createError } from '../error';

const withdrawSecondaryClaim = '/staffing_user/{{staffing_users_id}}/events/{{events_id}}/secondary_claims/{{claims_id}}/withdraw';

class ClaimWithdrawTask extends Task {
  constructor($q, APIService, ClaimService, ClaimStatusService, LogService) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.ClaimService = ClaimService;
    this.ClaimStatusService = ClaimStatusService;
    this.LogService = LogService;
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set serializedClaim(claim) {
    this._serializedClaim = claim;
  }

  get serializedClaim() {
    return this._serializedClaim;
  }

  /**
   * Public methods
   */

  setClaim(claim) {
    this.serializedClaim = this.ClaimService.serialize(claim);
  }

  populate(data) {
    this.serializedClaim = data.serializedClaim;
  }

  serialize() {
    return {
      serializedClaim: this.serializedClaim,
    };
  }

  execute() {
    const serializedClaim = this.serializedClaim;
    const url = withdrawSecondaryClaim
      .replace('{{staffing_users_id}}', serializedClaim.staffing_users_id)
      .replace('{{events_id}}', serializedClaim.events_id)
      .replace('{{claims_id}}', serializedClaim.id);

    return this.APIService.post(url)
      .catch(response => {
        this.LogService.error("Error withdrawing claim; response:", response);
        return this.$q.reject(createError({
          error: 'ErrorWithdrawingClaim',
          message: 'There was an error withdrawing the claim',
          response,
        }));
      })
      .then(() => {
        // Update status in local object
        return this.$q
          .all([
            this.ClaimService.getLocalById(serializedClaim.id),
            this.ClaimStatusService.getWithdrawnStatus(),
          ])
          .then(results => {
            let [claim, withdrawnStatus] = results;
            claim.status = withdrawnStatus;
            return claim;
          });
      });
  }
}

export default ClaimWithdrawTask;
